import React, { useState, useEffect } from 'react';
import { scroller } from 'react-scroll'
import { fetchTrains } from '../actions';
import { mergeTrainsForStations } from '../services/trainsService';
import { eventsEmit } from '../services/appboxService';
import StationBlockRow from './trains/StationBlockRow';
import moment from 'moment-timezone';

const Trains = () => {
  const [dateStr, setDateStr] = useState('');
  const [timeStr, setTimeStr] = useState('');
  const [stations, setStations] = useState([]);

  useEffect(() => {
    import('../assets/stylesheets/mainline/trains.css')
      .then(() => {
      })
      .catch(err => console.error("CSSの読み込みエラー", err));

    async function fetchStations() {
      try {
        const data = await fetchTrains();
        // 駅情報と列車情報の結合。列車の走行位置に応じた駅の場所に列車情報を結合する
        const mergedStations = mergeTrainsForStations(data.trains);
        setStations(mergedStations);
        const dateTime = moment.tz(data.updated_at * 1000, 'Asia/Tokyo');
        setDateStr(dateTime.format("M月D日"));
        setTimeStr(dateTime.format("H時mm分"));
      } catch (error) {
        console.error('列車情報の取得に失敗:', error);
      }
    }

    fetchStations();
  }, []);

  const scrollTo = (target) => {
    scroller.scrollTo(target, {
      offset: -300,
    });
  };
  const trainIdMatch = location.href.match(/.train(\d+)$/);
  if (trainIdMatch) {
    scrollTo(`train${trainIdMatch[1]}`);
  } else {
    const stationIdMatch = location.href.match(/.(\d+)$/);
    if (stationIdMatch) {
      scrollTo(`${stationIdMatch[1]}`);
    }
  }

  const multipleIcons = (upTrains, downTrains) => {
    const trainsLength = [upTrains.honors.length, upTrains.local.length, downTrains.honors.length, downTrains.local.length];
    const maxLength = Math.max(...trainsLength);

    if (maxLength > 2) {
      return  ' three-units-icons';
    }

    if (maxLength > 1) {
      return ' two-units-icons';
    }

    return  '';
  };

  const clickStationName = (event, stationId, eventName, eventValue) => {
    event.preventDefault();
    eventsEmit(eventName, eventValue);
    history.replaceState(null, "", `#${stationId}`);
    window.location.href = event.currentTarget.href;
  };

  const clickTransferLine = (event, stationId, eventName, eventValue) => {
    event.preventDefault();
    eventsEmit(eventName, eventValue);
    history.replaceState(null, "", `#${stationId}`);
    window.location.href = event.currentTarget.href;
  };

  return (
    <div>
      <main className="tx-container">
        <div className="tx-datetime">
          <i className="getState"></i>
          <p className="tx3000-datetime-text">
            <span className="tx3000-date">{dateStr}　</span>
            <span className="tx3000-time">{timeStr}</span>
            現在
          </p>
        </div>
        <ul className="tx-station">
          {stations.map((station, index) => (
            <li key={index} className="tx-station-item">
              <div className={`station-info ${station.stationId}`}>
                <a href={`/lines/mainline/stations/${station.stationId}?return=true`}
                   onClick={
                    (event) => { clickStationName(event, station.stationId, 'train_position.station', { station: station.stationId }) }
                  }
                   className="station-info-link"
                >
                  <div className={`station-number-${station.number}`}></div>
                  <p className="station-name">
                    {station.name === '流山セントラルパーク' ? (
                      <React.Fragment>
                        流山<br />
                        セントラルパーク
                      </React.Fragment>
                    ) : (
                      station.name
                    )}
                  </p>
                </a>
              </div>
              <div className="station-line"></div>
              <div className={`station-block${multipleIcons(station.trains.up.sift, station.trains.down.sift)}`}>
                <StationBlockRow
                  trains={station.trains.up.sift}
                  keyPrefix={`sift_${station.number}`}
                  trainBodyClass="up"
                  eventsEmit={eventsEmit}
                />
                <StationBlockRow
                  trains={station.trains.down.sift}
                  keyPrefix={`sift_${station.number}`}
                  trainBodyClass="down"
                  eventsEmit={eventsEmit}
                />
              </div>
              {station.transferLines && (
                <a
                  href={`/lines/mainline/stations/${station.stationId}/transfer`}
                  onClick={(event) => { clickTransferLine(event, station.stationId, 'train_position', { station: station.stationId }) }}
                  className="transfers-station"
                >
                  乗り換え
                </a>
              )}
              <div className="station-block is-on-station">
                <StationBlockRow
                  trains={station.trains.up.bant}
                  keyPrefix={`bant_${station.number}`}
                  trainBodyClass="up"
                  eventsEmit={eventsEmit}
                />
                <StationBlockRow
                  trains={station.trains.down.bant}
                  keyPrefix={`bant_${station.number}`}
                  trainBodyClass="down"
                  eventsEmit={eventsEmit}
                />
              </div>
            </li>
          ))}
        </ul>
      </main>
    </div>
  );
};

export default Trains;
